import EngineeringIcon from "@mui/icons-material/Engineering";

export const reportGroups = [
  {
    title: "Quarterly Reports",
    icon: <EngineeringIcon color="primary" />,
    chipColor: "primary",
    reports: [
     
      {
        id: 32,
        name: "Financial Appraisal",
        route: "/reports/32",
        state: {
          reportType: "Financial Appraisal",
          title: "Financial Appraisal",
        },
      },
      {
        id: 33,
        name: "POH Unit Cost",
        route: "/reports/33",
        state: {
          reportType: "POH Unit Cost",
          title: "POH Unit Cost",
        },
      },
      {
        id: 34,
        name: "POH Expenditure",
        route: "/reports/34",
        state: {
          reportType: "POH Expenditure",
          title: "POH Expenditure",
        },
      },
     
     
    ],
  },
];